import type {z} from "zod";

import {AddSupplierFunctionBody} from "@project/sdk/engineering/zod";

export const addSupplierFunctionFormSchema = AddSupplierFunctionBody;
export type AddSupplierFunctionFormPayload = z.output<typeof addSupplierFunctionFormSchema>;

export const draftAddSupplierFunctionFormSchema = addSupplierFunctionFormSchema.partial();
export type DraftAddSupplierFunctionFormPayload = z.output<
  typeof draftAddSupplierFunctionFormSchema
>;
